import { Component, Input, OnInit } from '@angular/core';
import { AppUserState } from '../../stores/states/app.state';
import { ProfileImageComponent } from '../profile-image/profile-image.component';

@Component({
  selector: 'app-profile-image-stack',
  templateUrl: './profile-image-stack.component.html',
  styleUrls: ['./profile-image-stack.component.scss']
})
export class ProfileImageStackComponent implements OnInit {
  @Input() members: AppUserState[] = [];
  backgroundColors = ['bg-red-500', 'bg-green-500', 'bg-blue-500', 'bg-yellow-500', 'bg-purple-500'];
  @Input() MAX: number = 6;
  @Input() config: any = {
    size: 'w-8 h-8 text-sm'
  };
  @Input() hideTooltip: boolean = true;

  // Default gray color for users without a specific color
  public readonly DEFAULT_AVATAR_COLOR = '#6B7280';

  ngOnInit(): void {
    this.assignColors();
  }

  assignColors(): void {
    if (!this.members) return;

    this.members = this.members.map(member => {
      if (!member) return member;

      if (!member.settings) {
        member.settings = {};
      }

      const color = ProfileImageComponent.getAvatarColor(member, this.DEFAULT_AVATAR_COLOR);
      if (member.settings) {
        member.settings.avatarBgColor = color;
      }

      return member;
    });
  }

  getRandomHexColor(): string {
    return this.DEFAULT_AVATAR_COLOR;
  }

  getInitials(name: string): string {
    return name.split(' ').slice(0, 2).map(n => n[0]).join('').toUpperCase();
  }

  isDefaultColor(color: string): boolean {
    return color === this.DEFAULT_AVATAR_COLOR;
  }
}
